import request from 'superagent';
import _ from 'lodash';
import moment from 'moment';

const blogUrl = 'https://auth0.com/blog/';

export function getAllBlogPosts() {
  return new Promise(resolve => {
    request.get(`${blogUrl}press-release.json`).end((err, res) => {
      if (err) {
        return resolve([]);
      }

      return resolve(JSON.parse(res.text));
    });
  });
}

export function orderByFullDate(collection) {
  return _.orderBy(collection, item => -new Date(item.fullDate).getTime());
}

export function filterByYear(collection, year) {
  const yearValue = Number(year);
  return _.filter(collection, item => new Date(item.fullDate).getFullYear() === yearValue);
}

export function articlesGroupByMonthYear(articles) {
  const list = _.orderBy(articles, item => -new Date(item.fullDate).getTime());
  const result = _.groupBy(list, item => moment(item.fullDate, 'YYYY-MM-DD').format('MM-YYYY'));
  const data = [];
  _.each(result, (value, key) => {
    data.push({
      textDate: key,
      dates: value
    });
  });
  return data;
}

export function dateFormat(str) {
  return moment(str, 'YYYY-MM-DD').format('MMMM YYYY');
}

export function dateCardFormat(str) {
  return moment(str, 'YYYY-MM-DD').format('MMM DD, YYYY');
}

export function fullDateFormat(str) {
  return moment(str, 'YYYY-MM-DD').format('MM/DD/YYYY');
}

export function fullDateFormat2(str) {
  return moment(str, 'YYYY-MM-DD').format('MM-DD-YYYY');
}

export function fullDateFormat3(str) {
  return moment(str, 'YYYY-MM-DD').format('MMMM Do YYYY');
}

export default {
  getAllBlogPosts,
  orderByFullDate
};



// WEBPACK FOOTER //
// ./src/pages/press/utils.js